import {
  Box,
  Button,
  formatDateTime,
  FullPageSpinner,
  HStack,
  IconButton,
  Link,
  Text,
  VStack,
  WhiteCard,
} from '@elkaso-app/web-design';
import { useGetSupplierStatementApi } from 'apis/bnpl';
import { useEffect } from 'react';
import { changeTitle } from 'redux/actions';
import { useAppDispatch } from 'redux/hooks';
import { formatAmount } from 'pages/bnpl/utils/bnpl-statuses';
import { FiArrowLeft, FiDownload } from 'react-icons/fi';
import { useHistory, useParams } from 'react-router-dom';

const InfoItem = ({ label, value, children }: { label: string; value?: string; children?: React.ReactNode }) => (
  <Box minW='150px'>
    <Text fontSize='xs' color='gray.500'>
      {label}
    </Text>
    {children || <Text fontWeight='medium'>{value || '---'}</Text>}
  </Box>
);

export const SupplierStatementDetailScreen = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { isLoading, data: statementData } = useGetSupplierStatementApi(id);

  useEffect(() => {
    dispatch(changeTitle('BNPL - Supplier Statement'));
  }, [dispatch]);
  const statement = statementData?.data;

  if (isLoading) return <FullPageSpinner />;
  if (!statement) return <Text p='lg'>Statement not found</Text>;

  return (
    <VStack spacing='lg' align='stretch' p='lg'>
      <WhiteCard p='lg'>
        <HStack justify='space-between' mb='lg'>
          <HStack spacing='md'>
            <IconButton
              aria-label='back-to-statements'
              icon={<FiArrowLeft />}
              variant='ghost'
              size='sm'
              onClick={() => history.push('/app/bnpl/supplier-statements')}
            />
            <Text fontSize='xl' fontWeight='bold'>
              Supplier Statement #{statement.id}
            </Text>
          </HStack>
          {statement.documentUrl && (
            <Link href={statement.documentUrl} isExternal>
              <Button size='sm' variant='outline' colorScheme='red' leftIcon={<FiDownload />}>
                Download Document
              </Button>
            </Link>
          )}
        </HStack>

        <HStack spacing='xl' flexWrap='wrap'>
          <InfoItem label='Restaurant' value={statement.restaurant?.nameEn} />
          <InfoItem label='Supplier' value={statement.supplier?.name} />
          <InfoItem label='Facility ID' value={String(statement.facilityId)} />
          <InfoItem label='Statement Ref' value={statement.statementRef || '---'} />
          <InfoItem label='Amount' value={formatAmount(statement.statementAmount)} />
          <InfoItem label='Period Start' value={statement.periodStart} />
          <InfoItem label='Period End' value={statement.periodEnd} />
          <InfoItem label='Document' value={statement.originalFilename} />
          <InfoItem label='Notes' value={statement.notes || '---'} />
          <InfoItem label='Created By' value={String(statement.createdBy)} />
          <InfoItem label='Created At' value={formatDateTime(statement.createdAt)} />
        </HStack>
      </WhiteCard>
    </VStack>
  );
};
